<template>
  <div class="error-container">
    <div class="error-content text-center">
      <div class="logo-wrapper mb-8">
        <img src="@/assets/images/ZizbeyJobsLogo.svg" alt="ZizbeyJobs Logo" class="mx-auto h-16 opacity-80" />
      </div>
      
      <div class="illustration mb-8">
        <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-48 w-48 text-primary shadow-glow" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>

      <h1 class="text-6xl font-bold text-dark mb-4 drop-shadow-sm">404</h1>
      <p class="text-2xl text-gray-600 mb-8 max-w-md mx-auto leading-relaxed">
        Oops! The page you're looking for doesn't exist.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    goHome() {
      const hostname = window.location.hostname;
      if (hostname.includes('zjob.me')) {
        // Since home on zjob.me is 404, maybe redirect to main site or just stay
        window.location.href = "https://zizbeyjobs.com";
      } else {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style scoped>
.error-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at center, #ffffff 0%, #f3f4f6 100%);
  font-family: 'Inter', sans-serif;
}

.error-content {
  padding: 2rem;
  animation: fadeIn 0.8s ease-out;
}

.text-primary {
  color: #3b82f6; /* Modern blue */
}

.text-dark {
  color: #1f2937;
}

.btn-primary {
  background-color: #3b82f6;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.shadow-glow {
  filter: drop-shadow(0 0 15px rgba(59, 130, 246, 0.2));
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.logo-wrapper img {
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.05));
}
</style>
